/* This is the EMIS Pre material and school enviroment components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table style="height: 25px" border="1px;" width="740" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="
                height: 25px;
                width: 200px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សាលាអនុវត្តកម្មវិធីសិក្សា
            </td>
            <td
              style="
                height: 25px;
                width: 100px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <!--
              <v-text-field class="my-1 px-1" outline v-model="prog.pnam" />
              -->
              <!-- Add 25-26 -->
              <v-select
                class="px-1"
                v-model="prog.prog"
                :items="progType"
                item-text="text"
                item-value="value"
                outline                
                hide-details
                @keypress.native="onSelect($event)"
              >
              </v-select>
            </td>
            <td
              style="
                height: 25px;
                width: 50px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ប្រទេស
            </td>
            <td
              style="
                height: 25px;
                width: 100px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <v-text-field class="my-1 px-1" outline v-model="prog.con" />
            </td>
            <td
              style="
                height: 25px;
                width: 50px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ឆ្នាំ
            </td>
            <td
              style="
                height: 25px;
                width: 50px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <v-text-field class="my-1 px-1" outline v-model="prog.yar" type="number"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <table
        style="height: 61px; width: 740px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr style="height: 25px">
            <td
              style="
                height: 25px;
                width: 300px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ថ្នាក់
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតទាប
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតមធ្យម
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              កម្រិតខ្ពស់
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ថ្នាក់ចម្រុះ
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សរុបរួម
            </td>
          </tr>
          <tr v-for="(value, row) in d4.length" :key="row">
            <td
              style="
                height: 25px;
                width: 90px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ d4[row] }}
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="prog.pghr[row].dt[0]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="prog.pghr[row].dt[1]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="prog.pghr[row].dt[2]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <numberinput v-model="prog.pghr[row].dt[3]" style="width: 70px" />
            </td>
            <td
              style="
                height: 25px;
                width: 70px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <strong>{{ col[row] | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { d4, progType } from "@/utils/priascf/commonVariables.js";

export default {
  props: ["prog", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      d4: d4,
      progType: progType
    };
  },
  method: {
    onSelect: function (event) {
      // Type_care services
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        // 4 options
        this.prog.prog = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
  computed: {
    // need to update the total staff in json data
    col: function () {
      let result;
      let d = this.prog.pghr;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          r[ind] = (r[ind] || 0) + Number(b);
        });
        return r;
      }, []);
      return result;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>
